// // src/app/artisan/dashboard.jsx
// import { Link } from 'react-router-dom';
// import FurnitureNavbar from '../../../components/layout/Nav';
// import './artisandashboard.scss';
// import { useEffect, useState } from 'react';
// import withAuth from '../../auth/WithAuth';
// import { serverUrlAuth } from '../../../serverUrl';
// import SpotlightTour from '../../../components/SpotlightTour';
// import {
//   FaHandshake,
//   FaUserCircle,
//   FaTrophy,
//   FaProjectDiagram,
//   FaCheckCircle,
//   FaClock,
//   FaCalendarAlt,
//   FaChevronRight,
//   FaFileAlt,
//   FaBriefcase,
//   FaTimes,
//   FaMobileAlt,
//   FaUniversity,
//   FaCheck,
//   FaWallet
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';

// const ArtisanDashboard = () => {
//   const [artisanName, setArtisanName] = useState('');
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showTour, setShowTour] = useState(false);
//   const [showPaymentSetup, setShowPaymentSetup] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState('mpesa');
//   const [formData, setFormData] = useState({
//     mpesa_phone_number: '',
//     bank_name: '',
//     bank_account_name: '',
//     bank_account_number: '',
//     bank_branch: '',
//   });
//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   useEffect(() => {
//     const name = localStorage.getItem('full_name');
//     if (name) setArtisanName(name.split(' ')[0]);

//     const fetchDashboardData = async () => {
//       try {
//         const response = await serverUrlAuth.get('projects/artisan-dashboard/');
//         console.log('Artisan dashboard data:', response.data);
//         setDashboardData(response.data);
//       } catch (err) {
//         console.error('Error fetching artisan dashboard:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();

//     // Check if tour should be shown
//     const tourCompleted = localStorage.getItem('artisan_tour_completed');
//     if (!tourCompleted) {
//       setTimeout(() => {
//         setShowTour(true);
//         console.log('Artisan tour started!');
//       }, 1500);
//     } else {
//       // Tour already completed, check if payment setup is needed
//       checkPaymentSetup();
//     }
//   }, []);

//   const checkPaymentSetup = async () => {
//     try {
//       const response = await serverUrlAuth.get('users/artisan/profile/');
//       const data = response.data;
      
//       // Check if payment details exist
//       const hasPaymentDetails = data.payment_method && (
//         (data.payment_method === 'mpesa' && data.mpesa_phone_number) ||
//         (data.payment_method === 'bank' && data.bank_name && data.bank_account_number)
//       );

//       if (!hasPaymentDetails) {
//         setTimeout(() => {
//           setShowPaymentSetup(true);
//           console.log('Payment setup modal triggered!');
//         }, 1000);
//       }
//     } catch (error) {
//       console.error('Error checking payment details:', error);
//       // If error, show the payment setup
//       setTimeout(() => {
//         setShowPaymentSetup(true);
//       }, 1000);
//     }
//   };

//   const handleTourComplete = () => {
//     console.log('Artisan tour completed - setting localStorage');
//     setShowTour(false);
//     localStorage.setItem('artisan_tour_completed', 'true');
    
//     // After tour, check if payment setup is needed
//     checkPaymentSetup();
//   };

//   const handleTourSkip = () => {
//     console.log('Artisan tour skipped - setting localStorage');
//     setShowTour(false);
//     localStorage.setItem('artisan_tour_completed', 'true');
    
//     // After tour skip, check if payment setup is needed
//     checkPaymentSetup();
//   };

//   const handlePaymentMethodChange = (method) => {
//     setPaymentMethod(method);
//     setErrors({});
//   };

//   const handlePaymentInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: '' }));
//     }
//   };

//   const validatePaymentForm = () => {
//     const newErrors = {};

//     if (paymentMethod === 'mpesa') {
//       if (!formData.mpesa_phone_number) {
//         newErrors.mpesa_phone_number = 'Phone number is required';
//       } else {
//         const phone = formData.mpesa_phone_number.replace(/\s/g, '');
//         const phoneRegex = /^(?:\+254|0)?[17]\d{8}$/;
//         if (!phoneRegex.test(phone)) {
//           newErrors.mpesa_phone_number = 'Please enter a valid Kenyan phone number (e.g., 0712345678)';
//         }
//       }
//     } else if (paymentMethod === 'bank') {
//       if (!formData.bank_name) {
//         newErrors.bank_name = 'Bank name is required';
//       }
//       if (!formData.bank_account_name) {
//         newErrors.bank_account_name = 'Account name is required';
//       }
//       if (!formData.bank_account_number) {
//         newErrors.bank_account_number = 'Account number is required';
//       }
//     }

//     return newErrors;
//   };

//   const handlePaymentSubmit = async (e) => {
//     e.preventDefault();

//     const validationErrors = validatePaymentForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = {
//         payment_method: paymentMethod,
//         ...formData,
//       };

//       await serverUrlAuth.patch('users/artisan/profile/', payload);
      
//       toast.success('Payment details saved successfully!');
//       setShowPaymentSetup(false);
//       localStorage.setItem('artisan_payment_setup_completed', 'true');
//     } catch (error) {
//       console.error('Error saving payment details:', error);
//       if (error.response?.data) {
//         const errorMsg = typeof error.response.data === 'object' 
//           ? Object.values(error.response.data).flat().join(', ')
//           : error.response.data.message || 'Failed to save payment details';
//         toast.error(errorMsg);
//       } else {
//         toast.error('Failed to save payment details');
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handlePaymentSkip = () => {
//     setShowPaymentSetup(false);
//     localStorage.setItem('artisan_payment_setup_skipped', 'true');
//   };

//   // Reset tour function (for development)
//   const resetTour = () => {
//     console.log('Resetting artisan tour...');
//     localStorage.removeItem('artisan_tour_completed');
//     localStorage.removeItem('artisan_payment_setup_completed');
//     localStorage.removeItem('artisan_payment_setup_skipped');
//     setShowTour(false);
//     setShowPaymentSetup(false);
//     setTimeout(() => {
//       setShowTour(true);
//       console.log('Artisan tour reset and restarted!');
//     }, 100);
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="dashboard-loader">
//           <div className="wooden-spinner"></div>
//           <p>Crafting your experience...</p>
//         </div>
//       </>
//     );
//   }

//   const data = dashboardData || {};

//   // Define tour steps for artisan dashboard
//   const tourSteps = [
//     {
//       selector: '.hero-craftsmanship',
//       title: '👋 Welcome to Your Workshop!',
//       description: 'This is your Artisan dashboard. Everything you need to manage your projects, proposals, and client communications is right here.',
//       icon: '🔨',
//     },
//     {
//       selector: '.tour-dashboard',
//       title: '🏠 Your Dashboard',
//       description: 'This is your Artiza command center. Track your projects, manage proposals, and connect with clients all from one place.',
//       icon: '🏠',
//     },
//     {
//       selector: '.tour-browse-projects',
//       title: '🔍 Browse Projects',
//       description: 'Discover new project opportunities from clients looking for skilled artisans. Filter by category, budget, and timeline to find the perfect match.',
//       icon: '🔍',
//     },
//     {
//       selector: '.tour-my-projects',
//       title: '📋 Ongoing Projects',
//       description: "View all the projects you're currently working on. Track progress, see deadlines, and keep clients updated on your craftsmanship.",
//       icon: '📋',
//     },
//     {
//       selector: '.tour-my-proposals',
//       title: '📄 Sent Proposals',
//       description: "Review all the proposals you've submitted to clients. Track their status - pending, accepted, or declined - and follow up as needed.",
//       icon: '📄',
//     },
//     {
//       selector: '.tour-messages',
//       title: '💬 Messages',
//       description: 'Chat directly with clients about their projects. Discuss details, share progress updates, negotiate terms, and build lasting relationships.',
//       icon: '💬',
//     },
//     {
//       selector: '.tour-payments',
//       title: '💰 Payments & Disbursements',
//       description: 'View your payment history, track project disbursements, and monitor your earnings. See when payments have been processed and how much you have received.',
//       icon: '💰',
//     },
//     {
//       selector: '.btn-primary-custom',
//       title: '🚀 Browse Projects',
//       description: 'Find new project opportunities that match your skills. Browse through client requests and submit proposals to win new work.',
//       icon: '🚀',
//     },
//     {
//       selector: '.btn-secondary-custom',
//       title: '💬 Messages',
//       description: 'View your messages and see if you have any unread notifications. Stay on top of conversations with clients about your projects.',
//       icon: '💬',
//     },
//     {
//       selector: '.stats-dashboard',
//       title: '📈 Your Stats',
//       description: "Get a quick overview of your activity. See open projects, work in progress, completed work, and proposals you've submitted.",
//       icon: '📈',
//     },
//     {
//       selector: '.projects-showcase',
//       title: '🎯 Ongoing Projects',
//       description: "Track the progress of your active projects. See what you're working on, completion percentages, and delivery deadlines.",
//       icon: '🎯',
//     },
//     {
//       selector: '.pending-requests-card',
//       title: '📋 Projects Needing Artisans',
//       description: 'Browse client projects waiting for skilled artisans like you. Review the requirements, budget, and submit your proposal.',
//       icon: '📋',
//     },
//     {
//       selector: '.negotiations-card',
//       title: '🤝 Active Negotiations',
//       description: 'Review ongoing price and timeline negotiations with clients. Respond to counter-offers and reach agreements on project terms.',
//       icon: '🤝',
//     },
//   ];

//   return (
//     <>
//       <FurnitureNavbar />

//       <SpotlightTour
//         steps={tourSteps}
//         tourKey="artisan_tour_completed"
//         onComplete={handleTourComplete}
//         onSkip={handleTourSkip}
//         enabled={showTour}
//       />

//       {/* Payment Setup Modal */}
//       {showPaymentSetup && (
//         <div className="payment-setup-overlay">
//           <div className="payment-setup-modal">
//             <button className="close-btn" onClick={handlePaymentSkip}>
//               <FaTimes />
//             </button>

//             <div className="modal-header">
//               <div className="header-icon">
//                 <FaWallet />
//               </div>
//               <h2>Payment Setup</h2>
//               <p>Set up how you'd like to receive payments for your work</p>
//             </div>

//             <form onSubmit={handlePaymentSubmit}>
//               {/* Payment Method Selection */}
//               <div className="payment-methods">
//                 <div 
//                   className={`method-option ${paymentMethod === 'mpesa' ? 'active' : ''}`}
//                   onClick={() => handlePaymentMethodChange('mpesa')}
//                 >
//                   <div className="method-icon">
//                     <FaMobileAlt />
//                   </div>
//                   <div className="method-info">
//                     <h4>M-Pesa</h4>
//                     <p>Receive payments directly to your M-Pesa</p>
//                   </div>
//                   {paymentMethod === 'mpesa' && (
//                     <div className="check-mark">
//                       <FaCheck />
//                     </div>
//                   )}
//                 </div>

//                 <div 
//                   className={`method-option ${paymentMethod === 'bank' ? 'active' : ''}`}
//                   onClick={() => handlePaymentMethodChange('bank')}
//                 >
//                   <div className="method-icon">
//                     <FaUniversity />
//                   </div>
//                   <div className="method-info">
//                     <h4>Bank Transfer</h4>
//                     <p>Receive payments directly to your bank account</p>
//                   </div>
//                   {paymentMethod === 'bank' && (
//                     <div className="check-mark">
//                       <FaCheck />
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* M-Pesa Fields */}
//               {paymentMethod === 'mpesa' && (
//                 <div className="form-group">
//                   <label htmlFor="mpesa_phone_number">
//                     M-Pesa Phone Number <span className="required">*</span>
//                   </label>
//                   <input
//                     type="tel"
//                     id="mpesa_phone_number"
//                     name="mpesa_phone_number"
//                     value={formData.mpesa_phone_number}
//                     onChange={handlePaymentInputChange}
//                     placeholder="e.g., 0712345678"
//                     className={errors.mpesa_phone_number ? 'error' : ''}
//                     disabled={isSubmitting}
//                   />
//                   {errors.mpesa_phone_number && (
//                     <span className="error-message">{errors.mpesa_phone_number}</span>
//                   )}
//                   <small className="hint">
//                     Enter the phone number registered with M-Pesa
//                   </small>
//                 </div>
//               )}

//               {/* Bank Fields */}
//               {paymentMethod === 'bank' && (
//                 <div className="bank-fields">
//                   <div className="form-group">
//                     <label htmlFor="bank_name">
//                       Bank Name <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       id="bank_name"
//                       name="bank_name"
//                       value={formData.bank_name}
//                       onChange={handlePaymentInputChange}
//                       placeholder="e.g., KCB, Equity, Co-operative"
//                       className={errors.bank_name ? 'error' : ''}
//                       disabled={isSubmitting}
//                     />
//                     {errors.bank_name && (
//                       <span className="error-message">{errors.bank_name}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="bank_account_name">
//                       Account Name <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       id="bank_account_name"
//                       name="bank_account_name"
//                       value={formData.bank_account_name}
//                       onChange={handlePaymentInputChange}
//                       placeholder="Full name on the bank account"
//                       className={errors.bank_account_name ? 'error' : ''}
//                       disabled={isSubmitting}
//                     />
//                     {errors.bank_account_name && (
//                       <span className="error-message">{errors.bank_account_name}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="bank_account_number">
//                       Account Number <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       id="bank_account_number"
//                       name="bank_account_number"
//                       value={formData.bank_account_number}
//                       onChange={handlePaymentInputChange}
//                       placeholder="Your bank account number"
//                       className={errors.bank_account_number ? 'error' : ''}
//                       disabled={isSubmitting}
//                     />
//                     {errors.bank_account_number && (
//                       <span className="error-message">{errors.bank_account_number}</span>
//                     )}
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="bank_branch">Bank Branch (Optional)</label>
//                     <input
//                       type="text"
//                       id="bank_branch"
//                       name="bank_branch"
//                       value={formData.bank_branch}
//                       onChange={handlePaymentInputChange}
//                       placeholder="e.g., Nairobi, Mombasa Road"
//                       disabled={isSubmitting}
//                     />
//                   </div>
//                 </div>
//               )}

//               {/* Form Actions */}
//               <div className="form-actions">
//                 <button
//                   type="button"
//                   className="btn btn-skip"
//                   onClick={handlePaymentSkip}
//                   disabled={isSubmitting}
//                 >
//                   Skip for now
//                 </button>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={isSubmitting}
//                 >
//                   {isSubmitting ? (
//                     <>
//                       <span className="spinner"></span>
//                       Saving...
//                     </>
//                   ) : (
//                     'Save Payment Details'
//                   )}
//                 </button>
//               </div>

//               <p className="footer-note">
//                 You can update these settings anytime from your profile
//               </p>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Debug: Reset Tour Button */}
//       {/* {process.env.NODE_ENV === 'development' && (
//         <button
//           onClick={resetTour}
//           style={{
//             position: 'fixed',
//             bottom: '20px',
//             right: '20px',
//             zIndex: 9999,
//             background: '#673200',
//             color: 'white',
//             border: 'none',
//             padding: '10px 20px',
//             borderRadius: '8px',
//             cursor: 'pointer',
//             fontSize: '13px',
//             fontWeight: '600',
//             boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//           }}
//         >
//           🔄 Reset Tour & Payment Setup
//         </button>
//       )} */}

//       <div className="modern-dashboard artisan-dashboard">
//         {/* Hero Section */}
//         <section className="hero-craftsmanship">
//           <div className="hero-pattern"></div>
//           <div className="hero-content-modern-artisan">
//             <div className="welcome-badge">
//               <span className="badge-icon">🔨</span>
//               <span>
//                 Welcome back,{' '}
//                 {artisanName || data.artisan_name?.split(' ')[0] || 'Artisan'}!
//               </span>
//             </div>
//             <h1 className="hero-title">
//               <span className="gradient-text">Your Craftsmanship</span>
//               <span className="hero-accent">Builds Dreams</span>
//             </h1>
//             <p className="hero-subtitle">
//               Showcase your skills, connect with clients, and bring beautiful
//               furniture designs to life.
//             </p>
//             <div className="hero-actions">
//               <Link
//                 to="/browse-project-requests"
//                 className="btn-primary-custom tour-browse-projects"
//               >
//                 <FaBriefcase /> Browse Projects
//               </Link>
//               <Link
//                 to="/messaging"
//                 className="btn-secondary-custom tour-messages"
//               >
//                 Messages
//                 {data.total_notifications > 0 && (
//                   <span className="notification-dot">
//                     {data.total_notifications}
//                   </span>
//                 )}
//               </Link>
//             </div>
//           </div>
//         </section>

//         {/* Quick Stats Dashboard */}
//         <div className="stats-dashboard">
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#67320020', color: '#673200' }}
//             >
//               <FaProjectDiagram />
//             </div>
//             <div className="stat-content">
//               <h3>{data.open_projects || 0}</h3>
//               <p>Open Projects</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#4caf5020', color: '#4caf50' }}
//             >
//               <FaCheckCircle />
//             </div>
//             <div className="stat-content">
//               <h3>{data.ongoing_projects_count || 0}</h3>
//               <p>In Progress</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#ff980020', color: '#ff9800' }}
//             >
//               <FaCheckCircle />
//             </div>
//             <div className="stat-content">
//               <h3>{data.completed_projects_count || 0}</h3>
//               <p>Completed</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div
//               className="stat-icon-wrapper"
//               style={{ background: '#9c27b020', color: '#9c27b0' }}
//             >
//               <FaFileAlt />
//             </div>
//             <div className="stat-content">
//               <h3>{data.proposals_submitted || 0}</h3>
//               <p>Proposals Sent</p>
//             </div>
//           </div>
//         </div>

//         {/* Ongoing Projects Grid Section */}
//         {data.ongoing_projects && data.ongoing_projects.length > 0 && (
//           <div className="projects-showcase">
//             <div className="section-header-modern">
//               <h2>
//                 <span className="header-icon">🎯</span>
//                 Your Ongoing Projects
//                 <span className="header-line"></span>
//               </h2>
//               <Link
//                 to="/my-projects"
//                 className="view-all-link tour-my-projects"
//               >
//                 View All Projects <FaChevronRight />
//               </Link>
//             </div>
//             <div className="projects-grid-modern">
//               {data.ongoing_projects.map((project) => (
//                 <div key={project.id} className="project-card-modern">
//                   <div className="project-header">
//                     <div className="project-title-section">
//                       <h3>{project.title}</h3>
//                       <span className="project-artisan">
//                         Client: {project.client_name}
//                       </span>
//                     </div>
//                     <div className="project-budget">
//                       KSh {(project.agreed_cost || 0).toLocaleString()}
//                     </div>
//                   </div>
//                   <div className="progress-modern">
//                     <div className="progress-bar-modern">
//                       <div
//                         className="progress-fill-modern"
//                         style={{ width: `${project.progress || 0}%` }}
//                       ></div>
//                     </div>
//                     <div className="progress-stats">
//                       <span>{project.progress || 0}% Complete</span>
//                       <span>
//                         Due{' '}
//                         {project.deadline
//                           ? new Date(project.deadline).toLocaleDateString()
//                           : 'Not set'}
//                       </span>
//                     </div>
//                   </div>
//                   <div className="project-footer">
//                     <div className="milestone-chip">
//                       <span>
//                         📅 Deadline:{' '}
//                         {project.deadline
//                           ? new Date(project.deadline).toLocaleDateString()
//                           : 'Flexible'}
//                       </span>
//                     </div>
//                     <Link
//                       to={`/messaging?project=${project.id}`}
//                       className="project-action"
//                     >
//                       View Updates →
//                     </Link>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Two Column Layout */}
//         <div className="dashboard-grid-modern">
//           {/* Left Column - Pending Requests (Projects to bid on) */}
//           <div className="dashboard-card pending-requests-card">
//             <div className="card-header">
//               <h3>
//                 <FaBriefcase /> Projects Needing Artisans
//               </h3>
//               <Link to="/browse-project-requests" className="card-link">
//                 Browse all →
//               </Link>
//             </div>
//             <div className="pending-requests-list">
//               {data.pending_requests && data.pending_requests.length > 0 ? (
//                 data.pending_requests.slice(0, 5).map((request) => (
//                   <div key={request.id} className="request-item">
//                     <div className="request-header">
//                       <h4>{request.title}</h4>
//                       <div className="request-budget">
//                         KSh {request.budget?.toLocaleString() || 0}
//                       </div>
//                     </div>
//                     <div className="request-details">
//                       <p className="request-description">
//                         {request.description?.substring(0, 100)}...
//                       </p>
//                       <div className="request-meta">
//                         <span>
//                           <FaUserCircle /> {request.client}
//                         </span>
//                         <span>
//                           <FaCalendarAlt /> Due:{' '}
//                           {request.deadline
//                             ? new Date(request.deadline).toLocaleDateString()
//                             : 'Flexible'}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="request-footer">
//                       <Link
//                         to={`/browse-project-requests?id=${request.id}`}
//                         className="submit-proposal-btn"
//                       >
//                         Submit Proposal →
//                       </Link>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="empty-requests">
//                   <p>No open projects available at the moment</p>
//                   <p className="text-muted">
//                     Check back later for new opportunities
//                   </p>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Right Column - Active Negotiations */}
//           <div className="dashboard-card negotiations-card">
//             <div className="card-header">
//               <h3>
//                 <FaHandshake /> Active Negotiations
//               </h3>
//               <Link to="/messages" className="card-link">
//                 View all →
//               </Link>
//             </div>
//             <div className="negotiations-list">
//               {data.active_negotiations &&
//               data.active_negotiations.length > 0 ? (
//                 data.active_negotiations.map((negotiation) => (
//                   <div key={negotiation.id} className="negotiation-item">
//                     <div className="negotiation-header">
//                       <h4>{negotiation.project_title}</h4>
//                       {negotiation.unread_messages > 0 && (
//                         <span className="unread-badge">
//                           {negotiation.unread_messages} new
//                         </span>
//                       )}
//                     </div>
//                     <p className="client-name">
//                       Client: {negotiation.client_name}
//                     </p>
//                     <div className="price-info">
//                       <span>
//                         Proposed: KSh{' '}
//                         {negotiation.initial_price?.toLocaleString() || 0}
//                       </span>
//                       {negotiation.current_offer && (
//                         <span className="counter-offer">
//                           → KSh{' '}
//                           {negotiation.current_offer?.toLocaleString() || 0}
//                         </span>
//                       )}
//                     </div>
//                     <div className="last-activity">
//                       <FaClock /> Last: {negotiation.last_activity}
//                     </div>
//                     <Link to={`/messaging`} className="continue-btn">
//                       Continue Discussion →
//                     </Link>
//                   </div>
//                 ))
//               ) : (
//                 <div className="empty-negotiations">
//                   <p>No active negotiations</p>
//                   <Link to="/browse-project-requests" className="browse-link">
//                     Browse projects to start negotiating
//                   </Link>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Recent Activity / Updates Section */}
//         <div className="recent-activity-section">
//           <div className="section-header-modern">
//             <h2>
//               <span className="header-icon">📋</span>
//               Recent Activity
//             </h2>
//           </div>
//           <div className="activity-grid">
//             {/* Proposals Submitted */}
//             {data.proposals_submitted > 0 && (
//               <div className="activity-card">
//                 <div className="activity-icon">
//                   <FaFileAlt />
//                 </div>
//                 <div className="activity-content">
//                   <h4>Proposals Submitted</h4>
//                   <p>
//                     You have submitted {data.proposals_submitted} proposal
//                     {data.proposals_submitted !== 1 ? 's' : ''}
//                   </p>
//                   <Link
//                     to="/my-proposals"
//                     className="activity-link tour-my-proposals"
//                   >
//                     View your proposals →
//                   </Link>
//                 </div>
//               </div>
//             )}

//             {/* Ongoing Projects Update */}
//             {data.ongoing_projects_count > 0 && (
//               <div className="activity-card">
//                 <div className="activity-icon">
//                   <FaProjectDiagram />
//                 </div>
//                 <div className="activity-content">
//                   <h4>Projects in Progress</h4>
//                   <p>
//                     You are currently working on {data.ongoing_projects_count}{' '}
//                     project{data.ongoing_projects_count !== 1 ? 's' : ''}
//                   </p>
//                   <Link to="/my-projects" className="activity-link">
//                     View your projects →
//                   </Link>
//                 </div>
//               </div>
//             )}

//             {/* Completed Projects */}
//             {data.completed_projects_count > 0 && (
//               <div className="activity-card">
//                 <div className="activity-icon">
//                   <FaTrophy />
//                 </div>
//                 <div className="activity-content">
//                   <h4>Completed Projects</h4>
//                   <p>
//                     You have successfully completed{' '}
//                     {data.completed_projects_count} project
//                     {data.completed_projects_count !== 1 ? 's' : ''}
//                   </p>
//                   <Link to="/completed-projects" className="activity-link">
//                     View completed →
//                   </Link>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Tips & Insights for Artisans */}
//         <div className="tips-section">
//           <div className="tips-card">
//             <div className="tips-icon">💡</div>
//             <div className="tips-content">
//               <h4>Pro Tips for Success</h4>
//               <ul>
//                 <li>
//                   ✓ Respond to messages quickly to build trust with clients
//                 </li>
//                 <li>
//                   ✓ Submit detailed proposals with clear pricing and timelines
//                 </li>
//                 <li>
//                   ✓ Share progress photos regularly to keep clients engaged
//                 </li>
//                 <li>✓ Build your portfolio to showcase your best work</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanDashboard, 'artisan');



// src/pages/artisan/Dashboard.jsx
import { Link } from 'react-router-dom';
import './artisandashboard.scss';
import { useEffect, useState } from 'react';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import SpotlightTour from '../../../components/SpotlightTour';
import Sidebar from '../../../components/layout/Sidebar';
import {
  FaHandshake,
  FaUserCircle,
  FaTrophy,
  FaProjectDiagram,
  FaCheckCircle,
  FaClock,
  FaCalendarAlt,
  FaChevronRight,
  FaFileAlt,
  FaBriefcase,
  FaTimes,
  FaMobileAlt,
  FaUniversity,
  FaCheck,
  FaWallet,
  FaEnvelope,
  FaSyncAlt,
  FaArrowRight,
  FaLayerGroup,
  FaBolt,
  FaBell,
} from 'react-icons/fa';
import { toast } from 'react-toastify';

const ArtisanDashboard = () => {
  const [artisanName, setArtisanName] = useState('');
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [activeSection, setActiveSection] = useState('overview');
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('mpesa');
  const [formData, setFormData] = useState({
    mpesa_phone_number: '',
    bank_name: '',
    bank_account_name: '',
    bank_account_number: '',
    bank_branch: '',
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchDashboardData = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const response = await serverUrlAuth.get('projects/artisan-dashboard/');
      setDashboardData(response.data);
    } catch (err) {
      console.error('Error fetching artisan dashboard:', err);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const name = localStorage.getItem('full_name');
    if (name) setArtisanName(name.split(' ')[0]);

    fetchDashboardData();

    const tourCompleted = localStorage.getItem('artisan_tour_completed');
    if (!tourCompleted) {
      setTimeout(() => setShowTour(true), 1500);
    } else {
      checkPaymentSetup();
    }
  }, []);

  const checkPaymentSetup = async () => {
    try {
      const response = await serverUrlAuth.get('users/artisan/profile/');
      const data = response.data;

      const hasPaymentDetails =
        data.payment_method &&
        ((data.payment_method === 'mpesa' && data.mpesa_phone_number) ||
          (data.payment_method === 'bank' &&
            data.bank_name &&
            data.bank_account_number));

      if (!hasPaymentDetails) {
        setTimeout(() => setShowPaymentSetup(true), 1000);
      }
    } catch (error) {
      console.error('Error checking payment details:', error);
      setTimeout(() => setShowPaymentSetup(true), 1000);
    }
  };

  const handleTourComplete = () => {
    setShowTour(false);
    localStorage.setItem('artisan_tour_completed', 'true');
    checkPaymentSetup();
  };

  const handleTourSkip = () => {
    setShowTour(false);
    localStorage.setItem('artisan_tour_completed', 'true');
    checkPaymentSetup();
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
    setErrors({});
  };

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validatePaymentForm = () => {
    const newErrors = {};

    if (paymentMethod === 'mpesa') {
      if (!formData.mpesa_phone_number) {
        newErrors.mpesa_phone_number = 'Phone number is required';
      } else {
        const phone = formData.mpesa_phone_number.replace(/\s/g, '');
        const phoneRegex = /^(?:\+254|0)?[17]\d{8}$/;
        if (!phoneRegex.test(phone)) {
          newErrors.mpesa_phone_number =
            'Please enter a valid Kenyan phone number (e.g., 0712345678)';
        }
      }
    } else if (paymentMethod === 'bank') {
      if (!formData.bank_name) newErrors.bank_name = 'Bank name is required';
      if (!formData.bank_account_name)
        newErrors.bank_account_name = 'Account name is required';
      if (!formData.bank_account_number)
        newErrors.bank_account_number = 'Account number is required';
    }

    return newErrors;
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validatePaymentForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        payment_method: paymentMethod,
        ...formData,
      };

      await serverUrlAuth.patch('users/artisan/profile/', payload);

      toast.success('Payment details saved successfully!');
      setShowPaymentSetup(false);
      localStorage.setItem('artisan_payment_setup_completed', 'true');
    } catch (error) {
      console.error('Error saving payment details:', error);
      if (error.response?.data) {
        const errorMsg =
          typeof error.response.data === 'object'
            ? Object.values(error.response.data).flat().join(', ')
            : error.response.data.message || 'Failed to save payment details';
        toast.error(errorMsg);
      } else {
        toast.error('Failed to save payment details');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePaymentSkip = () => {
    setShowPaymentSetup(false);
    localStorage.setItem('artisan_payment_setup_skipped', 'true');
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="dashboard-loader">
          <div className="orbit-spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p>Crafting your experience…</p>
        </div>
      </>
    );
  }

  const data = dashboardData || {};

  const tourSteps = [
    {
      selector: '.hero',
      title: '👋 Welcome to Your Workshop!',
      description:
        'This is your Artisan dashboard. Everything you need to manage your projects, proposals, and client communications is right here.',
      icon: '🔨',
    },
    {
      selector: '.tour-dashboard',
      title: '🏠 Your Dashboard',
      description:
        'Track your projects, manage proposals, and connect with clients all from one place.',
      icon: '🏠',
    },
    {
      selector: '.tour-browse-projects',
      title: '🔍 Browse Projects',
      description:
        'Discover new project opportunities from clients looking for skilled artisans.',
      icon: '🔍',
    },
    {
      selector: '.tour-my-projects',
      title: '📋 Ongoing Projects',
      description:
        "View all the projects you're currently working on. Track progress and keep clients updated.",
      icon: '📋',
    },
    {
      selector: '.tour-my-proposals',
      title: '📄 Sent Proposals',
      description:
        "Review all the proposals you've submitted to clients and follow up as needed.",
      icon: '📄',
    },
    {
      selector: '.tour-messages',
      title: '💬 Messages',
      description: 'Chat directly with clients about their projects.',
      icon: '💬',
    },
    {
      selector: '.tour-payments',
      title: '💰 Payments & Disbursements',
      description:
        'View your payment history and monitor your earnings from completed projects.',
      icon: '💰',
    },
    {
      selector: '.btn-primary-custom',
      title: '🚀 Browse Projects',
      description:
        'Find new project opportunities that match your skills and submit proposals.',
      icon: '🚀',
    },
    {
      selector: '.stats-dashboard',
      title: '📈 Your Stats',
      description:
        "A quick overview of your activity — open projects, work in progress, completed work, and proposals.",
      icon: '📈',
    },
    {
      selector: '.projects-showcase',
      title: '🎯 Ongoing Projects',
      description:
        "Track the progress of your active projects and delivery deadlines.",
      icon: '🎯',
    },
    {
      selector: '.pending-requests-card',
      title: '📋 Projects Needing Artisans',
      description:
        'Browse client projects waiting for skilled artisans like you.',
      icon: '📋',
    },
    {
      selector: '.negotiations-card',
      title: '🤝 Active Negotiations',
      description:
        'Review ongoing price and timeline negotiations with clients.',
      icon: '🤝',
    },
  ];

  const heroStats = [
    {
      key: 'open',
      icon: <FaProjectDiagram />,
      label: 'Open Projects',
      value: data.open_projects || 0,
      sub:
        data.open_projects > 0 ? 'Available to send proposals' : 'None available',
      accent: 'gold',
    },
    {
      key: 'ongoing',
      icon: <FaClock />,
      label: 'In Progress',
      value: data.ongoing_projects_count || 0,
      sub:
        data.ongoing_projects_count > 0
          ? 'Active work'
          : 'No work in progress',
      accent: 'blue',
    },
    {
      key: 'completed',
      icon: <FaTrophy />,
      label: 'Completed',
      value: data.completed_projects_count || 0,
      sub: 'Delivered successfully',
      accent: 'violet',
    },
    {
      key: 'proposals',
      icon: <FaFileAlt />,
      label: 'Proposals Sent',
      value: data.proposals_submitted || 0,
      sub:
        data.proposals_submitted > 0
          ? 'Awaiting replies from clients'
          : 'None submitted yet',
      accent: 'emerald',
    },
  ];

  const unread = data.total_notifications || 0;

  const sections = [
    { key: 'overview', label: 'Overview', icon: <FaLayerGroup /> },
    { key: 'projects', label: 'Projects', icon: <FaProjectDiagram /> },
    { key: 'activity', label: 'Activity', icon: <FaBolt /> },
  ];

  return (
    <>
      <Sidebar />

      <SpotlightTour
        steps={tourSteps}
        tourKey="artisan_tour_completed"
        onComplete={handleTourComplete}
        onSkip={handleTourSkip}
        enabled={showTour}
      />

      {/* Payment Setup Modal */}
      {showPaymentSetup && (
        <div className="payment-setup-overlay">
          <div className="payment-setup-modal">
            <button className="close-btn" onClick={handlePaymentSkip}>
              <FaTimes />
            </button>

            <div className="modal-header">
              <div className="header-icon">
                <FaWallet />
              </div>
              <h2>Payment Setup</h2>
              <p>Set up how you'd like to receive payments for your work</p>
            </div>

            <form onSubmit={handlePaymentSubmit}>
              <div className="payment-methods">
                <div
                  className={`method-option ${
                    paymentMethod === 'mpesa' ? 'active' : ''
                  }`}
                  onClick={() => handlePaymentMethodChange('mpesa')}
                >
                  <div className="method-icon">
                    <FaMobileAlt />
                  </div>
                  <div className="method-info">
                    <h4>M-Pesa</h4>
                    <p>Receive payments directly to your M-Pesa</p>
                  </div>
                  {paymentMethod === 'mpesa' && (
                    <div className="check-mark">
                      <FaCheck />
                    </div>
                  )}
                </div>

                <div
                  className={`method-option ${
                    paymentMethod === 'bank' ? 'active' : ''
                  }`}
                  onClick={() => handlePaymentMethodChange('bank')}
                >
                  <div className="method-icon">
                    <FaUniversity />
                  </div>
                  <div className="method-info">
                    <h4>Bank Transfer</h4>
                    <p>Receive payments directly to your bank account</p>
                  </div>
                  {paymentMethod === 'bank' && (
                    <div className="check-mark">
                      <FaCheck />
                    </div>
                  )}
                </div>
              </div>

              {paymentMethod === 'mpesa' && (
                <div className="form-group">
                  <label htmlFor="mpesa_phone_number">
                    M-Pesa Phone Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    id="mpesa_phone_number"
                    name="mpesa_phone_number"
                    value={formData.mpesa_phone_number}
                    onChange={handlePaymentInputChange}
                    placeholder="e.g., 0712345678"
                    className={errors.mpesa_phone_number ? 'error' : ''}
                    disabled={isSubmitting}
                  />
                  {errors.mpesa_phone_number && (
                    <span className="error-message">
                      {errors.mpesa_phone_number}
                    </span>
                  )}
                  <small className="hint">
                    Enter the phone number registered with M-Pesa
                  </small>
                </div>
              )}

              {paymentMethod === 'bank' && (
                <div className="bank-fields">
                  <div className="form-group">
                    <label htmlFor="bank_name">
                      Bank Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="bank_name"
                      name="bank_name"
                      value={formData.bank_name}
                      onChange={handlePaymentInputChange}
                      placeholder="e.g., KCB, Equity, Co-operative"
                      className={errors.bank_name ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                    {errors.bank_name && (
                      <span className="error-message">{errors.bank_name}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_account_name">
                      Account Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="bank_account_name"
                      name="bank_account_name"
                      value={formData.bank_account_name}
                      onChange={handlePaymentInputChange}
                      placeholder="Full name on the bank account"
                      className={errors.bank_account_name ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                    {errors.bank_account_name && (
                      <span className="error-message">
                        {errors.bank_account_name}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_account_number">
                      Account Number <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="bank_account_number"
                      name="bank_account_number"
                      value={formData.bank_account_number}
                      onChange={handlePaymentInputChange}
                      placeholder="Your bank account number"
                      className={errors.bank_account_number ? 'error' : ''}
                      disabled={isSubmitting}
                    />
                    {errors.bank_account_number && (
                      <span className="error-message">
                        {errors.bank_account_number}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="bank_branch">Bank Branch (Optional)</label>
                    <input
                      type="text"
                      id="bank_branch"
                      name="bank_branch"
                      value={formData.bank_branch}
                      onChange={handlePaymentInputChange}
                      placeholder="e.g., Nairobi, Mombasa Road"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              )}

              <div className="form-actions">
                <button
                  type="button"
                  className="btn btn-skip"
                  onClick={handlePaymentSkip}
                  disabled={isSubmitting}
                >
                  Skip for now
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      Saving...
                    </>
                  ) : (
                    'Save Payment Details'
                  )}
                </button>
              </div>

              <p className="footer-note">
                You can update these settings anytime from your profile
              </p>
            </form>
          </div>
        </div>
      )}

      <div className="modern-dashboard artisan-dashboard">
       

        {/* ============ HERO ============ */}
        <section className="hero tour-dashboard">
          <div className="hero-bg">
            <div className="hero-orb orb-1" />
            <div className="hero-orb orb-2" />
            <div className="hero-grid" />
          </div>

          <div className="hero-content">
            <div className="hero-text">
              <span className="hero-eyebrow">
                <span className="eyebrow-dot" /> ARTISAN · ARTIZA PLATFORM
              </span>
              <h1>
                Welcome back,{' '}
                <span className="accent">{artisanName || 'Artisan'}</span>
              </h1>
              <p>
                Showcase your skills, connect with clients, and bring beautiful
                furniture designs to life.
              </p>

              <div className="hero-actions">
                <Link
                  to="/browse-project-requests"
                  className="btn-primary-custom tour-browse-projects"
                >
                  <FaBriefcase /> Browse Projects
                </Link>
                <Link
                  to="/my-proposals"
                  className="btn-secondary-custom tour-my-proposals"
                >
                  <FaFileAlt /> My Proposals
                </Link>
                <Link
                  to="/messaging"
                  className="btn-secondary-custom tour-messages-btn"
                >
                  <FaEnvelope /> Messages
                  {unread > 0 && (
                    <span className="notification-dot">{unread}</span>
                  )}
                </Link>
              </div>
            </div>
          </div>

          <div className="hero-kpi-grid stats-dashboard">
            {heroStats.map((stat) => (
              <div
                key={stat.key}
                className={`hero-kpi accent-${stat.accent}`}
              >
                <div className="hero-kpi-glow" />
                <div className="hero-kpi-top">
                  <div className="hero-kpi-icon">{stat.icon}</div>
                </div>
                <div className="hero-kpi-label">{stat.label}</div>
                <div className="hero-kpi-value">{stat.value}</div>
                <div className="hero-kpi-sub">{stat.sub}</div>
                <div className="hero-kpi-bar" />
              </div>
            ))}
          </div>
        </section>

        {/* ============ SEGMENTED NAV ============ */}
        <div className="segment-nav">
          {sections.map((s) => (
            <button
              key={s.key}
              className={`segment ${
                activeSection === s.key ? 'active' : ''
              }`}
              onClick={() => setActiveSection(s.key)}
            >
              {s.icon}
              <span>{s.label}</span>
            </button>
          ))}
        </div>

        {/* ============ OVERVIEW ============ */}
        {activeSection === 'overview' && (
          <div className="section-reveal">
            <div className="overview-grid">
              {/* Ongoing Projects panel — full width top */}
              <section className="panel projects-panel projects-showcase tour-my-projects">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">01</span>
                    <div>
                      <h2>
                        <FaProjectDiagram /> Ongoing Projects
                      </h2>
                      <p>Track what you're working on right now</p>
                    </div>
                  </div>
                  <Link to="/my-projects" className="panel-link">
                    View all <FaChevronRight />
                  </Link>
                </div>

                {data.ongoing_projects && data.ongoing_projects.length > 0 ? (
                  <div className="projects-grid-modern">
                    {data.ongoing_projects.slice(0, 3).map((project) => (
                      <div
                        key={project.id}
                        className="project-card-modern"
                      >
                        <div className="project-header">
                          <div className="project-title-section">
                            <h3>{project.title}</h3>
                            <span className="project-artisan">
                              Client: {project.client_name || 'Client'}
                            </span>
                          </div>
                          <div className="project-budget">
                            KSh {(project.agreed_cost || 0).toLocaleString()}
                          </div>
                        </div>
                        <div className="progress-modern">
                          <div className="progress-bar-modern">
                            <div
                              className="progress-fill-modern"
                              style={{ width: `${project.progress || 0}%` }}
                            ></div>
                          </div>
                          <div className="progress-stats">
                            <span>{project.progress || 0}% complete</span>
                            <span>
                              Due{' '}
                              {project.deadline
                                ? new Date(
                                    project.deadline,
                                  ).toLocaleDateString()
                                : 'Not set'}
                            </span>
                          </div>
                        </div>
                        <div className="project-footer">
                          <Link
                            to={`/messaging?project=${project.id}`}
                            className="project-action"
                          >
                            View Updates <FaArrowRight />
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon-wrap">
                      <FaProjectDiagram />
                    </div>
                    <h3>No active projects yet</h3>
                    <p>
                      Once a client hires you for a project, it will appear
                      here.
                    </p>
                    <Link
                      to="/browse-project-requests"
                      className="empty-cta"
                    >
                      <FaBriefcase /> Browse projects
                    </Link>
                  </div>
                )}
              </section>

              {/* Bottom row — Pending Requests + Negotiations */}
              <div className="overview-bottom">
                <section className="panel pending-requests-card">
                  <div className="panel-header">
                    <div className="panel-title">
                      <span className="panel-number">02</span>
                      <div>
                        <h2>
                          <FaBriefcase /> Projects Needing Artisans
                        </h2>
                        <p>Client requests waiting for proposals</p>
                      </div>
                    </div>
                    <Link
                      to="/browse-project-requests"
                      className="panel-link"
                    >
                      Browse all <FaChevronRight />
                    </Link>
                  </div>
                  <div className="pending-requests-list">
                    {data.pending_requests &&
                    data.pending_requests.length > 0 ? (
                      data.pending_requests.slice(0, 3).map((request) => (
                        <div key={request.id} className="request-item">
                          <div className="request-header">
                            <h4>{request.title}</h4>
                            <div className="request-budget">
                              KSh {request.budget?.toLocaleString() || 0}
                            </div>
                          </div>
                          <div className="request-details">
                            <p className="request-description">
                              {request.description?.substring(0, 90)}...
                            </p>
                            <div className="request-meta">
                              <span>
                                <FaUserCircle /> {request.client}
                              </span>
                              <span>
                                <FaCalendarAlt /> Due:{' '}
                                {request.deadline
                                  ? new Date(
                                      request.deadline,
                                    ).toLocaleDateString()
                                  : 'Flexible'}
                              </span>
                            </div>
                          </div>
                          <div className="request-footer">
                            <Link
                              to={`/browse-project-requests?id=${request.id}`}
                              className="submit-proposal-btn"
                            >
                              Submit Proposal <FaArrowRight />
                            </Link>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="empty-requests">
                        <p>No open projects available at the moment</p>
                        <p className="text-muted">
                          Check back later for new opportunities
                        </p>
                      </div>
                    )}
                  </div>
                </section>

                <section className="panel negotiations-card">
                  <div className="panel-header">
                    <div className="panel-title">
                      <span className="panel-number">03</span>
                      <div>
                        <h2>
                          <FaHandshake /> Active Negotiations
                        </h2>
                        <p>Ongoing conversations with clients</p>
                      </div>
                    </div>
                    <Link to="/messaging" className="panel-link">
                      View all <FaChevronRight />
                    </Link>
                  </div>
                  <div className="negotiations-list">
                    {data.active_negotiations &&
                    data.active_negotiations.length > 0 ? (
                      data.active_negotiations.slice(0, 3).map((negotiation) => (
                        <div
                          key={negotiation.id}
                          className="negotiation-item"
                        >
                          <div className="negotiation-header">
                            <h4>{negotiation.project_title}</h4>
                            {negotiation.unread_messages > 0 && (
                              <span className="unread-badge">
                                {negotiation.unread_messages} new
                              </span>
                            )}
                          </div>
                          <p className="client-name">
                            Client: {negotiation.client_name}
                          </p>
                          <div className="price-info">
                            <span>
                              Proposed: KSh{' '}
                              {negotiation.initial_price?.toLocaleString() || 0}
                            </span>
                            {negotiation.current_offer && (
                              <span className="counter-offer">
                                → KSh{' '}
                                {negotiation.current_offer?.toLocaleString() ||
                                  0}
                              </span>
                            )}
                          </div>
                          <div className="last-activity">
                            <FaClock /> Last: {negotiation.last_activity}
                          </div>
                          <Link to="/messaging" className="continue-btn">
                            Continue Discussion <FaArrowRight />
                          </Link>
                        </div>
                      ))
                    ) : (
                      <div className="empty-negotiations">
                        <p>No active negotiations</p>
                        <Link
                          to="/browse-project-requests"
                          className="browse-link"
                        >
                          Browse projects to start negotiating
                        </Link>
                      </div>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        )}

        {/* ============ PROJECTS ============ */}
        {activeSection === 'projects' && (
          <div className="section-reveal">
            <section className="panel">
              <div className="panel-header">
                <div className="panel-title">
                  <span className="panel-number">01</span>
                  <div>
                    <h2>All Ongoing Projects</h2>
                    <p>Every active project you have with clients</p>
                  </div>
                </div>
                <Link to="/my-projects" className="panel-link">
                  View all <FaChevronRight />
                </Link>
              </div>

              {data.ongoing_projects && data.ongoing_projects.length > 0 ? (
                <div className="projects-grid-modern full">
                  {data.ongoing_projects.map((project) => (
                    <div key={project.id} className="project-card-modern">
                      <div className="project-header">
                        <div className="project-title-section">
                          <h3>{project.title}</h3>
                          <span className="project-artisan">
                            Client: {project.client_name || 'Client'}
                          </span>
                        </div>
                        <div className="project-budget">
                          KSh {(project.agreed_cost || 0).toLocaleString()}
                        </div>
                      </div>
                      <div className="progress-modern">
                        <div className="progress-bar-modern">
                          <div
                            className="progress-fill-modern"
                            style={{ width: `${project.progress || 0}%` }}
                          ></div>
                        </div>
                        <div className="progress-stats">
                          <span>{project.progress || 0}% complete</span>
                          <span>
                            Due{' '}
                            {project.deadline
                              ? new Date(
                                  project.deadline,
                                ).toLocaleDateString()
                              : 'Not set'}
                          </span>
                        </div>
                      </div>
                      <div className="project-footer">
                        <Link
                          to={`/messaging?project=${project.id}`}
                          className="project-action"
                        >
                          View Updates <FaArrowRight />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon-wrap">
                    <FaProjectDiagram />
                  </div>
                  <h3>No active projects yet</h3>
                  <p>
                    Once a client hires you for a project, it will appear here.
                  </p>
                  <Link to="/browse-project-requests" className="empty-cta">
                    <FaBriefcase /> Browse projects
                  </Link>
                </div>
              )}
            </section>
          </div>
        )}

        {/* ============ ACTIVITY ============ */}
        {activeSection === 'activity' && (
          <div className="section-reveal">
            <div className="activity-full-grid">
              <section className="panel pending-requests-card">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">01</span>
                    <div>
                      <h2>
                        <FaBriefcase /> Projects Needing Artisans
                      </h2>
                      <p>Client requests waiting for proposals</p>
                    </div>
                  </div>
                  <Link
                    to="/browse-project-requests"
                    className="panel-link"
                  >
                    Browse all <FaChevronRight />
                  </Link>
                </div>
                <div className="pending-requests-list">
                  {data.pending_requests &&
                  data.pending_requests.length > 0 ? (
                    data.pending_requests.map((request) => (
                      <div key={request.id} className="request-item">
                        <div className="request-header">
                          <h4>{request.title}</h4>
                          <div className="request-budget">
                            KSh {request.budget?.toLocaleString() || 0}
                          </div>
                        </div>
                        <div className="request-details">
                          <p className="request-description">
                            {request.description?.substring(0, 90)}...
                          </p>
                          <div className="request-meta">
                            <span>
                              <FaUserCircle /> {request.client}
                            </span>
                            <span>
                              <FaCalendarAlt /> Due:{' '}
                              {request.deadline
                                ? new Date(
                                    request.deadline,
                                  ).toLocaleDateString()
                                : 'Flexible'}
                            </span>
                          </div>
                        </div>
                        <div className="request-footer">
                          <Link
                            to={`/browse-project-requests?id=${request.id}`}
                            className="submit-proposal-btn"
                          >
                            Submit Proposal <FaArrowRight />
                          </Link>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty-requests">
                      <p>No open projects available at the moment</p>
                    </div>
                  )}
                </div>
              </section>

              <section className="panel negotiations-card">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">02</span>
                    <div>
                      <h2>
                        <FaHandshake /> Active Negotiations
                      </h2>
                      <p>Ongoing conversations with clients</p>
                    </div>
                  </div>
                  <Link to="/messaging" className="panel-link">
                    View all <FaChevronRight />
                  </Link>
                </div>
                <div className="negotiations-list">
                  {data.active_negotiations &&
                  data.active_negotiations.length > 0 ? (
                    data.active_negotiations.map((negotiation) => (
                      <div key={negotiation.id} className="negotiation-item">
                        <div className="negotiation-header">
                          <h4>{negotiation.project_title}</h4>
                          {negotiation.unread_messages > 0 && (
                            <span className="unread-badge">
                              {negotiation.unread_messages} new
                            </span>
                          )}
                        </div>
                        <p className="client-name">
                          Client: {negotiation.client_name}
                        </p>
                        <div className="price-info">
                          <span>
                            Proposed: KSh{' '}
                            {negotiation.initial_price?.toLocaleString() || 0}
                          </span>
                          {negotiation.current_offer && (
                            <span className="counter-offer">
                              → KSh{' '}
                              {negotiation.current_offer?.toLocaleString() || 0}
                            </span>
                          )}
                        </div>
                        <div className="last-activity">
                          <FaClock /> Last: {negotiation.last_activity}
                        </div>
                        <Link to="/messaging" className="continue-btn">
                          Continue Discussion <FaArrowRight />
                        </Link>
                      </div>
                    ))
                  ) : (
                    <div className="empty-negotiations">
                      <p>No active negotiations</p>
                    </div>
                  )}
                </div>
              </section>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withAuth(ArtisanDashboard, 'artisan');